module.exports = __webpack_public_path__ + "static/media/clipboard-img.181562a1.jpg";